<template>
  <router-link class="floating-action-button" :to="to">
    <p-icon class="add-icon" icon-name="add"
               boxed background="blue"
               size="large"
               color="blue"/>
  </router-link>

</template>
<script lang="ts" setup>
import { RouterLink } from 'vue-router';

defineProps<{to: Link}>();

</script>
<style lang="scss" scoped>

  .floating-action-button {
    position: absolute;
    z-index: 2;
    right: 16px;
    top: -60px;

    .add-icon {
      min-width: 44px;
      min-height: 44px;
      max-width: 44px;
      max-height: 44px;
    }
  }

</style>
